import {createClient} from '@supabase/supabase-js'

const supabaseUrl = 'https://cqu0pka5g6h3420e2jl0.baseapi.memfiredb.com'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImV4cCI6MzMwMDQwMDA4MSwiaWF0IjoxNzIzNjAwMDgxLCJpc3MiOiJzdXBhYmFzZSJ9.IQDQR8H7tCSLgPxc01KKMSFxevverKktvSuC4uRD-eg'
console.log('create supabase client')
const supabase = createClient(supabaseUrl, supabaseKey)

export {supabase}